import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {IMaskModule} from 'angular-imask';
import {SharedModule} from '../../../../../../shared/shared.module';
import {CodeComponent} from './code.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    IMaskModule,
    SharedModule
  ],
  declarations: [
    CodeComponent
  ],
  entryComponents: [
    CodeComponent
  ],
  exports: [
    CodeComponent
  ]
})

export class CodeModule {}
